import { lazy } from 'react'
import { RouteObject } from 'react-router'

const LotStatusMovementDetail = lazy(() => import('./LotStatusMovementPage'))

export const SALES_MOVEMENT_PATH = {
  SUBMENU: '/business-insight/:projectID/lot-status-movement',
}

const LotStatusMovementRoutes: RouteObject[] = [
  {
    path: 'lot-status-movement',
    children: [
      {
        path: '',
        element: <LotStatusMovementDetail />,
      },
    ],
  },
]

export default LotStatusMovementRoutes
